var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_svg__export",
    fill: "#000",
    fillRule: "nonzero",
    transform: "translate(-693 -378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_svg__[Logo]-Facebook",
    transform: "translate(693 378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_svg__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "facebook_svg__Combined-Shape",
    d: "M16.495 23.907v-9.258h3.108l.465-3.608h-3.573V8.737c0-1.044.29-1.756 1.788-1.756l1.91-.001V3.753c-.33-.044-1.464-.142-2.783-.142-2.755 0-4.64 1.681-4.64 4.769v2.66H9.653v3.609h3.115v9.258H1.32A1.32 1.32 0 0 1 0 22.587V1.32C0 .591.59 0 1.32 0h21.267c.729 0 1.32.59 1.32 1.32v21.267c0 .729-.591 1.32-1.32 1.32z"
  })))))));
};
export default SvgFacebook;